import React from "react"
import { Image } from "@chakra-ui/image"
import { Box, VStack, Flex, Heading } from "@chakra-ui/layout"
import ResponsiveBlock from "~components/shared/layout/responsive-block"

import Pattern from "~images/pages/pims/pattern-gray.png"
import BookADemoButton from "~components/shared/book-a-demo-button"
import { PIMSCopy } from "../resources/types"
import Paragraph from "~components/shared/text/paragraph"

interface Props {
    copy: PIMSCopy
}

export default function TitleSection({ copy }: Props) {
    const { pims, title, subtitle, logo } = copy

    const heroTitle =
        title || `Get more out of your ${pims} Software with Chckvet`
    const heroSubtitle =
        subtitle ||
        `Chckvet's analytics, scheduling, communications, & reviews software helps veterinary practices save more time, more money, & more pets. Because Chckvet works with ${pims}, your practice can streamline appointments, client communication, revenue generation, practice reporting, and much more!`

    return (
        <Flex
            w="full"
            align="center"
            justify="center"
            pos="relative"
            pt={{ base: 32, xl: 0 }}
            height={{ base: "fit-content", xl: "70dvh" }}
            pb={12}
            color="gray.900"
        >
            <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                clipPath={{
                    base: "ellipse(150% 100% at 50% -5%)",
                    md: "ellipse(100% 100% at 50% -5%)",
                }}
                overflow="hidden"
                bgGradient="linear(to-br, white, gray.50, gray.300)"
            >
                <Box
                    position="absolute"
                    transform="rotate(5deg)"
                    height="300%"
                    opacity={0.5}
                    top={-40}
                    bottom={0}
                    left={-40}
                    right={0}
                    bgImage={Pattern}
                />
            </Box>
            <ResponsiveBlock isWide position="relative">
                <VStack h="full" w="full" spacing={{ base: 8, md: 16 }}>
                    <Image
                        src={logo}
                        alt={`${pims} logo`}
                        w={{ base: "80%", md: "30%" }}
                        objectFit="contain"
                    />
                    <VStack spacing={{ base: 4, md: 8 }}>
                        <Heading
                            as="h1"
                            size={{ base: "lg", md: "3xl" }}
                            fontWeight="black"
                            textAlign="center"
                            color="navy.700"
                        >
                            {heroTitle}
                        </Heading>
                        <Paragraph
                            fontSize={{ base: "sm", md: "lg" }}
                            textAlign="center"
                        >
                            {heroSubtitle}
                        </Paragraph>
                        <BookADemoButton size={{ base: "md", md: "lg" }} />
                    </VStack>
                </VStack>
            </ResponsiveBlock>
        </Flex>
    )
}
